import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export const SWFL_AREAS = [
  { name: "Cape Coral", slug: "cape-coral" },
  { name: "Fort Myers", slug: "fort-myers" },
  { name: "Naples", slug: "naples" },
  { name: "Bonita Springs", slug: "bonita-springs" },
  { name: "Estero", slug: "estero" },
  { name: "Lee County", slug: "lee-county" },
  { name: "Collier County", slug: "collier-county" },
];

/**
 * Reusable row of SWFL area pills. Variant "light" for use on white/mist
 * backgrounds, "dark" for use on navy.
 */
export default function AreaPills({
  variant = "light",
  to = "/service-areas",
  testIdPrefix = "area-pill",
  showIcon = true,
  className = "",
}) {
  const isDark = variant === "dark";
  return (
    <ul className={`flex flex-wrap gap-2.5 ${className}`} aria-label="Service areas">
      {SWFL_AREAS.map((area) => (
        <li key={area.slug}>
          <Link
            to={to}
            data-testid={`${testIdPrefix}-${area.slug}`}
            className={`group inline-flex items-center gap-1.5 rounded-full px-3.5 py-2 text-sm font-medium shadow-soft transition-colors ${
              isDark
                ? "border border-white/15 bg-white/[0.06] text-white/90 hover:border-aqua/60 hover:bg-white/[0.12]"
                : "border border-mist-line bg-white text-navy/85 hover:border-aqua/45 hover:bg-aqua/[0.06] hover:text-navy"
            }`}
          >
            {showIcon && (
              <span
                className={`h-1.5 w-1.5 rounded-full ${
                  isDark ? "bg-aqua" : "bg-aqua"
                } transition-transform group-hover:scale-125`}
                aria-hidden="true"
              />
            )}
            {!showIcon && <MapPin className="h-3 w-3 text-aqua" aria-hidden="true" />}
            {area.name}
          </Link>
        </li>
      ))}
    </ul>
  );
}
